<template>
  <div>
    <Control @add="addSession" @remove="removeSessionById" @edit="editSessionById" />
    <v-data-table
      v-model="selected"
      fixed-header
      :headers="headers"
      :items="sessions"
      :items-per-page="50"
      :footer-props="{
        'items-per-page-options': [10, 20, 30, 40, 50, -1]
      }"
      height="600"
      :single-select="true"
      show-select
      class="session-table"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      multi-sort
    >
      <template #header.label="{ header }">
        <div class="d-flex justify-space-between align-center">
          <span>{{ header.text }}</span>
        </div>
      </template>

      <template #header.date="{ header }">
        <div class="d-flex justify-space-between align-center">
          <span>{{ header.text }}</span>
          <!-- <TwoArrowSort class="session-table--sort-icon" /> -->
        </div>
      </template>

      <template #header.state="{ header }">
        <div class="d-flex justify-space-between align-center">
          <span>{{ header.text }}</span>
        </div>
      </template>

      <template #header.formName="{ header }">
        <div class="d-flex justify-space-between align-center">
          <span>{{ header.text }}</span>
        </div>
      </template>

      <template #header.minValid="{ header }">
        <div class="d-flex justify-space-between align-center">
          <span>{{ header.text }}</span>
        </div>
      </template>

      <template #header.minInterview="{ header }">
        <div class="d-flex justify-space-between align-center">
          <span>{{ header.text }}</span>
        </div>
      </template>

      <template #header.accessAndValidity="{ header }">
        <div class="d-flex justify-space-between align-center">
          <span>{{ header.text }}</span>
        </div>
      </template>

      <template #item.label="{ item }">
        <a class="linkToSessionDetails" @click.stop.prevent="$emit('set-session', item)">
          {{ item.label }}
        </a>
      </template>

      <template #item.date="{ item }">
        {{ formatTimeWithDayString(item.date) }}
      </template>

      <template #item.state="{ item }">
        {{ setState(item.state) }}
      </template>

      <template #item.accessAndValidity="{ item }">
        {{ formatTime(item.accessAndValidity) }}
      </template>
      <template #item.minValid="{ item }">
        {{ item.minValid.toFixed(2) }}
      </template>
      <template #item.minInterview="{ item }">
        {{ item.minInterview.toFixed(2) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { get, find } from 'lodash';
import { mapActions } from 'vuex';
import moment from 'moment/moment';

import { formatValues } from '@/mixins/formatValues.mixin';
import Control from '@/components/sessions/Control';

export default {
  name: 'SessionTable',
  components: {
    Control
  },
  mixins: [formatValues],
  props: {
    sessions: {
      type: Array,
      default: () => []
    },
    forms: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      singleSelect: true,
      selected: [],
      sortBy: ['date', 'createdAt'],
      sortDesc: [true, true] // desc, desc
    };
  },
  computed: {
    headers() {
      return [
        {
          text: 'Libellé',
          divider: true,
          align: 'start',
          sortable: false,
          width: '18%',
          value: 'label'
        },
        {
          text: 'Date session',
          divider: true,
          align: 'start',
          width: '11%',
          sortable: false,
          value: 'date'
        },
        {
          text: 'État',
          divider: true,
          align: 'start',
          width: '13%',
          sortable: false,
          value: 'state'
        },
        {
          text: 'Inscrits',
          divider: true,
          width: '4%',
          align: 'start',
          sortable: false,
          value: 'nbParticipant'
        },
        {
          text: 'Questionnaire',
          divider: true,
          align: 'start',
          width: '20%',
          sortable: false,
          value: 'formName'
        },
        {
          text: 'Note mini. pour accès',
          divider: true,
          width: '7%',
          align: 'start',
          sortable: false,
          value: 'minValid'
        },
        {
          text: 'Note mini. pour entretien',
          divider: true,
          width: '7%',
          align: 'start',
          sortable: false,
          value: 'minInterview'
        },
        {
          text: 'Fin accès',
          divider: true,
          width: '8%',
          align: 'start',
          sortable: false,
          value: 'accessAndValidity'
        },
        {
          text: 'Succès',
          divider: true,
          width: '4%',
          align: 'start',
          sortable: false,
          value: 'nbSuccess'
        },
        {
          text: 'Entretien',
          divider: true,
          width: '4%',
          align: 'start',
          sortable: false,
          value: 'nbInterview'
        },
        {
          text: 'Refus',
          divider: true,
          width: '4%',
          align: 'start',
          sortable: false,
          value: 'nbFail'
        }
      ];
    },
    selectedId() {
      return get(this.selected[0], 'id', null);
    },
    selectedSession() {
      if (!this.selectedId) {
        return {};
      }

      return find(this.sessions, { id: this.selectedId }) || {};
    },
    selectedState() {
      return get(this.selectedSession, 'state', null);
    }
  },
  methods: {
    ...mapActions('sessions', ['removeSession', 'editSession', 'newSession']),
    formatTimeWithDayString(date) {
      return moment(date).utcOffset(60).format('ddd DD/MM/YYYY');
    },

    removeSessionById() {
      if (!this.selectedId) {
        return;
      }

      this.$modals.open({
        name: 'RemoveSessionModal',
        payload: {
          state: this.selectedState,
          submit: () => {
            this.removeSession(this.selectedId);
          }
        }
      });
    },
    editSessionById() {
      if (!this.selectedId) {
        return;
      }

      this.$modals.open({
        name: 'SessionModal',
        payload: {
          oldValues: {
            label: this.selectedSession.label,
            date: this.selectedSession.date,
            formId: this.selectedSession.formName,
            accessAndValidity: this.selectedSession.accessAndValidity,
            state: this.selectedSession.state,
            minValid: this.selectedSession.minValid,
            minInterview: this.selectedSession.minInterview
          },
          forms: this.forms,
          submit: data => {
            this.editSession({ id: this.selectedId, data });
            this.selected = [];
          }
        }
      });
    },
    addSession() {
      this.$modals.open({
        name: 'SessionModal',
        payload: {
          oldValues: null,
          forms: this.forms,
          submit: data => {
            this.newSession(data);
          }
        }
      });
    }
  }
};
</script>

<style lang="scss">
.sessions-control-icon {
  padding: 0 4px;
}

.session-table {
  .v-data-table-header__icon {
    display: none;
  }

  .v-input--selection-controls__input {
    .v-icon {
      color: #3dd598 !important;
    }
  }

  &--sort-icon {
    min-width: 24px;
    min-height: 24px;
  }

  tr:nth-child(odd) {
    background-color: #f2f2f2;
  }
  td:nth-child(1) {
    border-left: thin solid rgba(0, 0, 0, 0.12);
  }

  tr:last-child {
    td {
      border-bottom: thin solid rgba(0, 0, 0, 0.12);
    }
  }

  thead {
    th {
      background-color: white;
      border-top: thin solid rgba(0, 0, 0, 0.12);
    }

    th:nth-child(1) {
      border-left: thin solid rgba(0, 0, 0, 0.12);
    }
  }

  .linkToSessionDetails {
    color: #07a;
    text-decoration: underline;

    &:hover {
      color: #333333;
    }
  }
}
</style>
